module.exports = __webpack_public_path__ + "img/arrow_forward_wide.04d56a50.svg";